import { render, staticRenderFns } from "./Home5.vue?vue&type=template&id=3d9d97ac&"
import script from "./Home5.vue?vue&type=script&lang=js&"
export * from "./Home5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports